// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'

import 'assets/lib/reset.css'

Vue.config.productionTip = false

Vue.use(VueI18n)

document.body.addEventListener('touchstart', function () { });

console.log((navigator.language || navigator.browserLanguage).toLowerCase())
let locale = (navigator.language || navigator.browserLanguage).toLowerCase()
const i18n = new VueI18n({
  locale,
  messages: {
    'zh-cn': require('@/assets/i18n/zh.json'),
    'en-us': require('@/assets/i18n/en.json')
  }
});

//  vue  {{ $t('common') }}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js